import React from "react";

export const IsRequired = (props) => {
  return <span style={{ color: "red" }}>*</span>;
};
